export const PositionsConst = {
  // end date statuses persisted and used internally
  EndDateStatuses: {
    Confirmed: 'Confirmed',
    NotConfirmed: 'Not Confirmed',
  },

  Worksites: {
    Remote: 'Remote',
    OnsiteRemote: 'Onsite/Remote',
    Onsite: 'Onsite',
  },

  ReservedType: {
    Reserved: 'Reserved',
    NotReserved: 'Not Reserved',
  },

  TalentTypes: {
    Lawyer: 'Lawyer',
    LawyerNonLegalWork: 'Lawyer - Non Legal Work',
    LegalSupport: 'Legal Support',
  },

  Roles: {
    teamLead: 'Team Lead',
    teamSecondment: 'Team Secondment',
    iSecondment: 'Individual Secondment',
    counsel: 'Counsel',
    other: 'Other',
  },
  Expansions: {
    opportunityInfo: 'opportunityInfo',
    candidatesInfo: 'candidatesInfo',
  },
} as const;

export type RolesType =
  (typeof PositionsConst.Roles)[keyof typeof PositionsConst.Roles];
export type TalentType =
  (typeof PositionsConst.TalentTypes)[keyof typeof PositionsConst.TalentTypes];
